import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React, { useContext } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import OrderExportConfigurationsPane from './Panes/OrderExportConfigurationsPane';
import OrderTableSettingsPane from './Panes/OrderTableSettingsPane';
import OrderSettingsPane from './Panes/OrderSettingsPane';
import OrderReorderUsersPane from './Panes/OrderReorderUsersPane';
import { CompanyRoleAssignmentContext } from '../../../../../context/CompanyRoleAssignmentContext';
import { CompanyRole } from '../../../../../types/company_role_assignment/companyRoleAssignment';
import { CsvUploadType } from '../../../../../types/csvUploadConfiguration';
import CsvUploadConfigurationUpdatePane from '../../../../components/CsvUploadConfiguration/CsvUploadConfigurationUpdatePane';
import CsvUploadConfigurationsScreen from '../../../../components/CsvUploadConfiguration/CsvUploadConfigurationsScreen';
import { t } from '../../../../../types/translation/Translator';
import CreateOrderExportConfigurationPane from './Panes/Export/Panes/CreateOrderExportConfigurationPane';
import UpdateOrderExportConfigurationPane from './Panes/Export/Panes/UpdateOrderExportConfigurationPane';
import ReorderUserRuleProvider from '../../../../../providers/ReorderUserRuleProvider';
import { Routing } from '../../../../../util/routes.util';
import { Tab, Tabs } from '../../../../components/Tabs';
import { Breadcrumbs } from '../../../../components/Breadcrumbs';
import OrderOverviewCrumb from '../../../../components/Breadcrumbs/crumbs/OrderOverviewCrumb';
import OrderSettingsCrumb from '../../../../components/Breadcrumbs/crumbs/OrderSettingsCrumb';
import OrderPdfTemplatesPane from './Panes/OrderPdfTemplatesPane';

export default function OrderSettingsScreen() {
  const navigate = useNavigate();

  const { hasRole } = useContext(CompanyRoleAssignmentContext);

  const isAdministrator = hasRole(CompanyRole.administrator);

  return (
    <div className='flex h-full flex-col overflow-hidden'>
      <Breadcrumbs>
        <OrderOverviewCrumb />
        <OrderSettingsCrumb current />
      </Breadcrumbs>
      <div className='content-y-breadcrumbs flex flex-grow flex-col overflow-hidden'>
        <Tabs padding>
          {isAdministrator ? (
            <Tab
              text={t(TranslationKey.orderSettings).singular.label}
              path={Routing.operations.orders.settings.settings()}
              key={'settings'}
            />
          ) : null}
          {isAdministrator ? (
            <Tab
              text={t(TranslationKey.tableSettings).singular.label}
              path={Routing.operations.orders.settings.tableSettings()}
              key={'table'}
            />
          ) : null}
          {isAdministrator ? (
            <Tab
              text={t(TranslationKey.reorderUsers).singular.label}
              path={Routing.operations.orders.settings.reorderUsers()}
              key={'reorder_users'}
            />
          ) : null}
          <Tab
            text={t(TranslationKey.importConfigurations).singular.label}
            path={Routing.operations.orders.settings.importConfigurations.overview()}
            key={'import_configurations'}
          />
          <Tab
            text={t(TranslationKey.reporting).singular.label}
            path={Routing.operations.orders.settings.report.overview()}
            key={'report'}
          />
          <Tab
            text={t(TranslationKey.pdfTemplate).plural.upper}
            path={Routing.operations.orders.settings.pdfTemplates()}
            key={'pdf_templates'}
          />
        </Tabs>
        <div className='flex-grow overflow-hidden'>
          <Routes>
            <Route path='report' element={<OrderExportConfigurationsPane />} />
            <Route path='report/create' element={<CreateOrderExportConfigurationPane />} />
            <Route path='report/update/:id' element={<UpdateOrderExportConfigurationPane />} />

            <Route path='settings' element={<OrderSettingsPane />} />
            <Route path='table' element={<OrderTableSettingsPane />} />
            <Route
              path='reorder_users'
              element={
                <ReorderUserRuleProvider>
                  <OrderReorderUsersPane />
                </ReorderUserRuleProvider>
              }
            />

            <Route
              path={'import_configurations/*'}
              element={<CsvUploadConfigurationsScreen type={CsvUploadType.order} backPath='/operations/orders' />}
            />
            <Route
              path={'import_configurations/update/:id/*'}
              element={
                <CsvUploadConfigurationUpdatePane
                  type={CsvUploadType.order}
                  onDone={() => navigate(Routing.operations.orders.settings.importConfigurations.overview())}
                />
              }
            />

            <Route path={'pdf_templates'} element={<OrderPdfTemplatesPane />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
